export const deepPink50 = "#f8ebfb";
export const deepPink100 = "#f6e1fa";
export const deepPink200 = "#edc3f5";
export const deepPink300 = "#e4a6f0";
export const deepPink400 = "#db88eb";
export const deepPink500 = "#d26be6";
export const deepPink600 = "#c05be0";
export const deepPink700 = "#ae4bda";
export const deepPink800 = "#9c3cd4";
export const deepPink900 = "#8b2dcf";
export const deepPink1000 = "#7212ba";
export const deepPinkA100 = "#f6c0fa";
export const deepPinkA200 = "#e8a0f2";
export const deepPinkA400 = "#bb35d9";
export const deepPinkA500 = "#9808c6";
export const deepPinkA1000 = "#492550";
